import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import Header from "components/core/Header";
import CourseForm from "components/course/CourseForm";
import CommonUtils from "utils/CommonUtils";
import courseActions from "actions/courseActions";
import {Course} from 'domain';
import {useNavigate} from "react-router-dom";

const CourseNewView = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const me = useSelector(({ auth }) => auth.me);
    const [myCourse, setCourse] = useState(new Course());
    const [errors, setErrors] = useState({});

    const handleChange = (key) => (evt, val) => {
        setCourse(myCourse.set(key, val ?? evt.target.value));
        setErrors({ ...errors, [key]: undefined });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            myCourse.set('tutor', me);
            myCourse.set('status', Course.STATUS_ACTIVE);

            await myCourse.inspect();

            CommonUtils.dispatcher(
                courseActions.save(myCourse),
                dispatch,
                'Course Created',
                'Failed To Create Course'
            ).then(() => {
                navigate(`/course/${myCourse.id}`);
            });
        } catch (err) {
            const newErrors = err.inner.reduce((acc, curr) => {
                acc[curr.path] = curr.message;
                return acc;
            }, {});
            setErrors(newErrors);
        }
    };

    return (
        <>
            <Header>
                New Courses
            </Header>
            <CourseForm course={myCourse} onChange={handleChange} onSave={handleSubmit} errors={errors} />
        </>
    );
}

CourseNewView.propTypes = {};

export default CourseNewView;
